<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="users"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Manage Users</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="openDialog">New User</v-btn>
                <v-dialog v-model="dialog" max-width="600px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
  
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.username" label="Username"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.password" label="Password" type="password" :rules="[v => !!v || 'Password is required']"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-checkbox v-model="editedItem.confirmed" label="Confirmed"></v-checkbox>
                            <v-checkbox v-model="editedItem.producer" label="Producer"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        dialog: false,
        headers: [
          { text: 'Username', value: 'username' , sortable: true},
          { text: 'Confirmed', value: 'confirmed' },
          { text: 'Producer', value: 'producer' },
          { text: 'Actions', value: 'actions' },          
        ],
        users: [],
        editedIndex: -1,
        editedItem: {
          id: '',
          username: '',
          password: '',
          confirmed: false,
          confirmation_token: '',
          producer: false,
        },
        defaultItem: {
          id: '',
          username: '',
          password: '',
          confirmed: false,
          confirmation_token: '',
          producer: false,
        },
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New User' : 'Edit User';
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        axios.get(process.env.VUE_APP_SERVER3 + '/users').then(response => {
          this.users = response.data;
        });
        console.log('init: ',this.users)
      },
      openDialog() {
        this.dialog = true;
      },
      editItem(item) {
        
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);

        console.log('item: ',this.editedItem)
        this.editedItem.confirmed= false;
        if(item.confirmed== 1)
          this.editedItem.confirmed = true;
        
        this.editedItem.producer = false;
        if(item.producer== 1)
          this.editedItem.producer = true;
        
        this.dialog = true;
      },
      deleteItem(item) {
        const index = this.users.indexOf(item);
        if (confirm('Are you sure you want to delete this item?')) {
          this.users.splice(index, 1);
          axios.delete(process.env.VUE_APP_SERVER3 + `/users/${item.id}`).then(response => {
            console.log(response);
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {     
        // Check if password field is not empty
        
          
        if(this.editedItem.username == '')
        {
          console.log('User empty:',this.editedItem);
          return;
        }
        this.editedItem.username = this.editedItem.username.toLowerCase();
        if (this.editedIndex > -1) {
          Object.assign(this.users[this.editedIndex], this.editedItem);
          
          axios.put(process.env.VUE_APP_SERVER3 + `/users/${this.editedItem.id}`, this.editedItem).then(response => {
            console.log(response);
          });
        } else {
          if (!this.editedItem.password) {
            console.log('Password is required');
            return;
          }
          
          // Genera un token di conferma per il nuovo utente
          this.editedItem.confirmation_token = Math.random().toString(36).substr(2, 9);
          axios.post(process.env.VUE_APP_SERVER3 +'/users', this.editedItem).then(response => {
            this.users.push(response.data);
          });
        }
        this.close();
      },
    },
  };
  </script>
  
  <style scoped>
  .menu-dialog {
    position: fixed;
    top: 30px;
    right: 40px;
    z-index: 2000;
  }
  </style>
  